function setSearchResultTitle() {
  const urlParams = new URLSearchParams(window.location.search);
  const method = urlParams.get("method");
  const searchMethodElement = document.getElementById("search-method");

  if (!searchMethodElement) return;

  searchMethodElement.innerText =
    method === "shortcut" ? "성공 사례" : "검색 결과";
}

function setSelectedHeaderNavigationItem() {
  const path = window.location.pathname;
  const [firstPath, secondPath] = path.split("/").filter(Boolean);

  document
    .querySelectorAll(".site-header-posts-filter > *")
    .forEach((element) => {
      element.classList.remove("selected-filter");
    });

  if (firstPath === "tag") {
    const element = document.querySelector(
      `.site-header-posts-filter > *[name="${secondPath}"]`
    );

    if (!element) return;

    element.classList.add("selected-filter");
  } else {
    const element = document.querySelector(
      '.site-header-posts-filter > *[name="all"]'
    );

    if (!element) return;

    element.classList.add("selected-filter");
  }
}

function setUtmSource() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");

  if (utmSource) sessionStorage.setItem("utm_source", utmSource);

  const sessionUtmSource = sessionStorage.getItem("utm_source");
  const addUtmSourceElements = document.querySelectorAll("a.add-utm-source");
  const addUtmSourceWithSuffixElements = document.querySelectorAll(
    "a.add-utm-source-with-suffix"
  );

  addUtmSourceElements.forEach((addUtmSourceElement) => {
    const isFirstUtm = !addUtmSourceElement.href.includes("?");

    addUtmSourceElement.href = `${addUtmSourceElement.href}${`${
      sessionUtmSource
        ? `${isFirstUtm ? "?" : "&"}utm_source=${sessionUtmSource}`
        : ""
    }`}`;
  });

  addUtmSourceWithSuffixElements.forEach((addUtmSourceWithSuffixElement) => {
    const isFirstUtm = !addUtmSourceWithSuffixElement.href.includes("?");

    addUtmSourceWithSuffixElement.href = `${
      addUtmSourceWithSuffixElement.href
    }${isFirstUtm ? "?" : "&"}utm_source=success_${
      sessionUtmSource ?? "organic"
    }`;
  });
}

function persistAndApplyQueryParameters() {
  // 현재 URL의 쿼리 파라미터 저장
  const urlParams = new URLSearchParams(window.location.search);
  const queryString = urlParams.toString();
  if (queryString) {
    sessionStorage.setItem("persistedQuery", queryString);
  }

  // 저장된 쿼리 파라미터를 모든 링크에 적용
  const savedQuery = sessionStorage.getItem("persistedQuery");
  if (!savedQuery) return;

  const savedParams = new URLSearchParams(savedQuery);

  document.querySelectorAll("a").forEach((link) => {
    const rawHref = link.getAttribute("href");
    if (!rawHref || rawHref.startsWith("#") || rawHref.startsWith("mailto:"))
      return;

    try {
      // 절대 URL로 변환 (상대경로 대응 포함)
      const url = new URL(rawHref, window.location.origin);
      const currentParams = url.searchParams;

      // 겹치는 파라미터 삭제 후 덮어쓰기
      for (const [key] of savedParams.entries()) {
        currentParams.delete(key); // 기존 제거
      }
      for (const [key, value] of savedParams.entries()) {
        currentParams.set(key, value); // 덮어쓰기
      }

      url.search = currentParams.toString();
      link.setAttribute("href", url.toString());
    } catch (err) {
      console.warn(`Invalid URL skipped: ${rawHref}`, err);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setSearchResultTitle();
  setSelectedHeaderNavigationItem();
  setUtmSource();
  persistAndApplyQueryParameters();
});
